import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import { IconClose, IconGoldPlay } from '@components/atoms/icons'
import IconButton from '@material-ui/core/IconButton'
import Image from '@components/atoms/image'
import Video from '@components/atoms/video'
import Embed from '@components/embed'
import * as amplitude from '@amplitude/analytics-browser'
import { useRouter } from 'next/router'
import useStyles from './modal-video.styles'

const ModalVideo = (props) => {
  const {
    imageAssociatedWithVideo,
    modalVideo,
    isNested,
    videoEmbedId,
  } = props

  const hideVideo = !modalVideo?.url && !videoEmbedId
  const styles = useStyles({ hideVideo })
  const theme = useTheme()
  const videoRef = useRef()
  const { pathname } = useRouter()
  const contentName = pathname === '/adm'
    ? 'ADM - Overview Video'
    : modalVideo?.description || ''

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [isOpen, toggleDialog] = React.useState(false)

  const handleClose = () => {
    toggleDialog(false)
  }

  const handlePlayVideo = () => {
    toggleDialog(true)
    amplitude.track('play-video', {
      content_name: contentName,
      status: 'start',
      page_path: pathname,
      video_url: null,
    })
  }

  const videoProps = { provider: 'vimeo', id: videoEmbedId, autoplay: true }

  return (
    <>
      <button
        className={`${styles.imgPromptContainer} ${isNested && 'isNested'}`}
        onClick={handlePlayVideo}
        aria-label={`${modalVideo?.description ?? ''}. Plays in dialog.`}
        type="button"
        disabled={hideVideo}
      >
        <div className={styles.modalVideoPlayIcon}><IconGoldPlay /></div>
        {imageAssociatedWithVideo?.url
          && (
            <Image
              className={styles.modalVideoImg}
              src={imageAssociatedWithVideo.url}
              alt={imageAssociatedWithVideo.description}
            />
          )}
      </button>
      <Dialog
        fullScreen={isMobile}
        open={isOpen}
        onClose={() => { toggleDialog(false) }}
        aria-modal="true"
        className={styles.modalContainer}
      >
        <Box className={styles.modal} data-testid="modal">
          <div className={styles.modalHeader}>
            <IconButton
              data-testid="close-modal"
              className={styles.closeIconButton}
              title="close"
              onClick={handleClose}
            >
              <IconClose className={styles.closeIcon} />
            </IconButton>
          </div>
          {videoEmbedId && <Embed {...videoProps} />}
          {(modalVideo?.url && !videoEmbedId) && (
            <Video
              src={modalVideo.url}
              autoPlay
              playsInline
              controls
              className={styles.videoContainer}
              ref={videoRef}
            />
          )}
        </Box>
      </Dialog>
    </>
  )
}

ModalVideo.propTypes = {
  imageAssociatedWithVideo: PropTypes.object,
  modalVideo: PropTypes.object,
  isNested: PropTypes.bool,
  videoEmbedId: PropTypes.string,
}

ModalVideo.defaultProps = {}

export default ModalVideo
